import axios from 'axios';
import { Toast } from 'vant';
import qs from 'qs';
import cookie from 'js-cookie';
import store from '@/store/index';
import config from '@/utils/config';

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 120000,
  headers: {
    'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
  },
  dataType: 'json',
});

// request拦截器 request interceptor
service.interceptors.request.use(
  (options) => {
    const { loading, data } = options;
    if (loading) {
      Toast.loading({
        message: loading,
        forbidClick: true,
      });
    }
    return {
      ...options,
      data: qs.stringify({
        appid: config.aid,
        accessToken: cookie.get('access_token') || '',
        User: _sdk_.getUserUnid() || store.state.userInfo.unid || '',
        login_Sesion: _sdk_.getUserLoginSession() || sessionStorage.getItem('user_token'),
        ...data,
      }),
    };
  },
  (error) => {
    Toast.clear();
    return Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    Toast.clear();
    if (response.status && response.status !== 200) {
      Toast.fail('服务端异常，请稍后再试');
      return Promise.reject(res);
    } else if (res.status && res.status !== 200) {
      Toast.fail({
        message: res?.message,
        duration: 3000,
        onClose: () => {
          if (res?.message?.indexOf('accessToken') !== -1) {
            location.replace('/app-mobile-member-logout.html?url=login');
          }
        },
      });
      return Promise.reject(res);
    } else {
      return Promise.resolve(res);
    }
  },
  (error) => {
    Toast.clear();
    return Promise.reject(error);
  }
);
export default service;
